/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum TypeEnum {
  "APM" = "APM"
}

/**
 * Alternative Payment Method (APM) verify request details
 */

// required attributes
const WalletVerifyRequestAPMDetailsR = t.interface({});

// optional attributes
const WalletVerifyRequestAPMDetailsO = t.partial({
  type: enumType<TypeEnum>(TypeEnum, "type"),

  redirectUrl: t.string
});

export const WalletVerifyRequestAPMDetails = t.intersection(
  [WalletVerifyRequestAPMDetailsR, WalletVerifyRequestAPMDetailsO],
  "WalletVerifyRequestAPMDetails"
);

export type WalletVerifyRequestAPMDetails = t.TypeOf<
  typeof WalletVerifyRequestAPMDetails
>;
